import React from "react";
import TableCell from "@mui/material/TableCell";

const TableEmptyToggleCell: React.FC = () => {
  return <TableCell padding="checkbox" />;
};

export default React.memo(TableEmptyToggleCell);
